const ORDER_SUMMARY_ROW_DESKTOP_HEIGHT = 108;
const ORDER_SUMMARY_ROW_TABLET_HEIGHT = 200;

export const getOrderListItemHeight = (isTablet: boolean) => {
    if (isTablet) {
        return ORDER_SUMMARY_ROW_TABLET_HEIGHT;
    }
    return ORDER_SUMMARY_ROW_DESKTOP_HEIGHT;
};
